import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { useLang } from '../context/LanguageContext';
import t from '../translations';
import './Footer.css';

export default function Footer() {
  const { lang } = useLang();
  const tx = t[lang];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="brand-row">
              <Logo size={44} />
              <span className="fname">XSC <span>Invest</span></span>
            </div>
            <p>{tx.ft_desc}</p>
          </div>
          <div className="footer-col">
            <h4>{tx.ft_nav}</h4>
            <ul className="footer-links">
              <li><Link to="/">{tx.home}</Link></li>
              <li><Link to="/services">{tx.services}</Link></li>
              <li><Link to="/contact">{tx.contact}</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>{tx.ft_contact}</h4>
            <ul className="footer-links">
              <li><a href="tel:7282264437">(728) 226-4437</a></li>
              <li><a href="mailto:xscinvest@gmail.com">xscinvest@gmail.com</a></li>
              <li><Link to="/contact">{tx.hero_cta}</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>{tx.ft_rights}</p>
          <span className="made-with">{tx.ft_tagline}</span>
        </div>
      </div>
    </footer>
  );
}
